// locationStore.js
import { writable } from 'svelte/store';

// Erstelle einen Store für die Koordinaten
export const locationStore = writable({
    latitude: null,
    longitude: null,
    accuracy: null,
    error: null,
});

/**
 * @type {number}
 */
let geoId = null;
/**
 * @type {string | number | NodeJS.Timeout}
 */
let backupTimeout = null;

// Funktion, um die Standortüberwachung zu starten
export function startLocationTracking() {
    if (navigator.geolocation) {
        // watchPosition überwacht kontinuierlich die Position
        geoId = navigator.geolocation.watchPosition(
            (position) => {
                console.log("Neue Position:", position.coords);
                // Store mit den neuesten Koordinaten aktualisieren
                locationStore.set({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    error: null,
                });

                // Falls wir eine Position bekommen haben, den Backup-Timeout zurücksetzen
                resetBackupTimeout();
            },
            (error) => {
                // Bei einem Fehler die Fehlermeldung im Store setzen
                locationStore.set({
                    latitude: null,
                    longitude: null,
                    accuracy: null,
                    error: error.message,
                });
            },
            {
                enableHighAccuracy: true,
                maximumAge: 2000, // Maximales Alter der Standortdaten
                timeout: 10000, // Maximal 10 Sekunden warten
            }
        );

        // Backup-Timeout setzen, um sicherzustellen, dass nach spätestens 2 Minuten eine Aktualisierung erfolgt
        setBackupTimeout();
    } else {
        locationStore.set({
            latitude: null,
            longitude: null,
            accuracy: null,
            error: "Geolocation wird nicht unterstützt.",
        });
    }
}

// Funktion, um die Standortüberwachung zu stoppen
export function stopLocationTracking() {
    if (geoId !== null) {
        navigator.geolocation.clearWatch(geoId);
        geoId = null;
    }

    // Den Backup-Timeout auch aufräumen
    if (backupTimeout !== null) {
        clearTimeout(backupTimeout);
        backupTimeout = null;
    }
}

// Backup-Timeout setzen (nach 2 Minuten aktualisieren)
function setBackupTimeout() {
    backupTimeout = setTimeout(() => {
        // Nach 2 Minuten eine einmalige Standortanfrage durchführen
        navigator.geolocation.getCurrentPosition(
            (position) => {
                locationStore.set({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    error: null,
                });
            },
            (error) => {
                locationStore.set({
                    latitude: null,
                    longitude: null,
                    accuracy: null,
                    error: error.message,
                });
            },
            {
                enableHighAccuracy: true,
            
            }
        );

        // Den Backup-Timeout erneut setzen, um sicherzustellen, dass die Position weiterhin aktualisiert wird
        setBackupTimeout();
    }, 120000); // 2 Minuten (120000 Millisekunden)
}

// Den Backup-Timeout zurücksetzen (falls wir bereits eine Position erhalten haben)
function resetBackupTimeout() {
    if (backupTimeout !== null) {
        clearTimeout(backupTimeout);
        setBackupTimeout();
    }
}